export default "__VITE_ASSET__52c241d5__"